import { safeSpacing } from "@/utils/const";
import Box from "@mui/material/Box";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";

export default function OutImgSection({
  img,
  altImg = "img",
  customStyle,
  boxStyle,
  side = "right",
  imgReverse,
}) {
  const theme = useTheme();

  const isXs = useMediaQuery(theme.breakpoints.down("sm"));
  const isSm = useMediaQuery(theme.breakpoints.between("sm", "md"));
  const isMd = useMediaQuery(theme.breakpoints.between("md", "lg"));
  const isLg = useMediaQuery(theme.breakpoints.between("lg", "xl"));
  const isXl = useMediaQuery(theme.breakpoints.up("xl"));

  const horizontal = (() => {
    if (isXs) return safeSpacing.horizontal.xs;
    if (isSm) return safeSpacing.horizontal.sm;
    if (isMd) return safeSpacing.horizontal.md;
    if (isLg) return safeSpacing.horizontal.lg;
    if (isXl) return safeSpacing.horizontal.xl;
    return safeSpacing.horizontal;
  })();

  const isRight = side === "right";

  // البوكس الخارجي: نطلّعه برا safe padding من الجنب الصح
  const outerSideSx = isXs
    ? { marginLeft: 0, marginRight: 0 } // موبايل: بلاش نيجتف مارجن
    : isRight
      ? { marginRight:  `-${horizontal}px` } // يمين بصريًا
      : { marginLeft: `-${horizontal}px` }; // شمال بصريًا

  // الصورة نفسها تلزق في الجنب الصح جوّه البوكس
  const innerAlignSx = isRight
    ? { marginLeft: "auto", marginRight: 0 } // يمين
    : { marginRight: "auto", marginLeft: 0 }; // شمال

  return (
    <Box
      sx={{
        position: "relative",
        width: { xs: "100%", md: "calc(100vw / 2)" },
        ...outerSideSx,
        ...boxStyle,
      }}
    >
      <Box
        component="img"
        src={img}
        alt={altImg}
        sx={{
          width: { xs: "100%", lg: "90%" },
          display: "block",
          borderRadius: isRight
            ? { xs: "20px", md: imgReverse ? "0 20px 20px 0" : "20px 0 0 20px" }
            : {
                xs: "20px",
                md: imgReverse ? "20px 0 0 20px" : "0 20px 20px 0",
              },
          ...innerAlignSx,
          ...customStyle,
        }}
      />
    </Box>
  );
}
